import ProjectCard from "./ProjectCard/ProjectCard";
import AnalystHiveLogo from "../../../assets/icons/ah_logo.svg";
import BBallLogo from "../../../assets/images/bballytics.png";

import "./Projects.scss";

const Projects = () => {
  return (
    <>
      <div className="cards">
        <ProjectCard title="AnalystHive" logoSVGSrc={AnalystHiveLogo} url="https://analysthive.com">
          AnalystHive is a platform that has a combination of tools for financial productivity. Implemented with a large
          variety of <b>cloud tools and services</b> it allows PDF document analysis at <b>large scale</b> with
          microscopic costs.
        </ProjectCard>
        <ProjectCard title="BBallytics" logoPNGSrc={BBallLogo} url="https://www.basketnews.lt">
          BBallytics - European Basketball analytics platform. Currently - a part of the BasketNews platform. It involves <b>data scraping</b> tools,
          <b> user management</b> CMS system and <b>Paypal payment</b> integration.
        </ProjectCard>
      </div>
    </>
  );
};

export default Projects;
